import React from "react";
import Search from "./images/searchIcon.svg";
import SearchIconBlue from "./images/blue-search.svg";
import PropTypes from "prop-types";

const SearchIcon = ({searchIconType}) => {
    return (
        searchIconType === "blue" ? <img src={SearchIconBlue} alt="search" /> : <img src={Search} alt="search" />
    );
};

SearchIcon.propTypes = {
    searchIconType: PropTypes.string
};

export default SearchIcon;
